import React from 'react';
import { Flex, Text } from 'roo-ui/components';
import FaqNavBar from 'pages/FAQs/FaqNavBar';
import PageBlock from 'components/PageBlock';

const FAQsLinks = () => {
  return (
    <PageBlock
      bg="white"
      pb={17}
      pt={10}
      px={[4, 6, 0]}
      data-print-style="page-block"
      backgroundColor="greys.porcelain"
      data-testid="faqs-links-block"
    >
      <Flex flexDirection="column" mb={1}>
        <Text fontSize="lg" fontWeight="bold">
          Still didn&apos;t find what you were looking for?
        </Text>
        <Text fontSize="md">Browse our popular FAQ topics.</Text>
      </Flex>
      <FaqNavBar />
    </PageBlock>
  );
};

export default FAQsLinks;
